import React from 'react';
import { displayMasterItem, displayDropDownItem } from '../util'
import Images from '../../../config/images'
import { Grid, Button, Form, Icon, Image, Loader} from 'semantic-ui-react'
import DateInputField from '../../../commonComponents/DateField'
import { packagingQualifiers, /*govAgencyCodesDRU,*/ lotNumbers } from '../util/constants'
import { DropDown } from '../../../commonComponents/dropDownCommon'
import InputField from '../../../commonComponents/Input'
import {  disclaimCheckboxdisabledxf } from '../../../util';
import CustomCheckbox from '../../formComponents/checkBox'
import _ from 'lodash'

import { savePGAItemField } from '../../api/setFormData'
export function paramyToDisclaimCodes(hsDataDtl_paramy,formType){
  let disclaimCodes = [];
  for(let deet of (hsDataDtl_paramy?.pgaMetadata?.tarriffPgaDetails || [])){
    if(!deet)continue;
    for(let program of (deet.programDetails || [])){
      if(!program)continue;
      if(program.formType == formType)
        disclaimCodes=program.disclaimCodes || [];
    }
  }
  return disclaimCodes;
}

export const disclaimReasonsPGAReasons = {
  A: "Product is not regulated by this agency",
  B: "Data is not required per agency guidance",
  C: "Data filed through other agency means",
  D: "Data filed through paper",
  E: "Product does not contain fish or wildlife, including live, dead, parts or products thereof, except as specifically exempted from declaration requirements",
}
const DisclaimCodes = ({
  FIELD_META,
  // type,
  // updateField,
  // saveField,
  // title,
  // values,
  // hasContact,
  // doesntHaveEntity,
  lineItemIndex,
  merchandiseId,
  pgaValues_xx,
  // identifierLabel = 'NAME',
  formType,
  pgaGuid,
  // errorMsg,
  validateField,
  // entityIdTypes,
  // containerList,
  updatePGAField,
  savePGAField,
  // saveRepeatedField,
  formDisabled,
  hsDataDtl_paramy,
  // addRepeatedItem,
  // lcpoIssuerList,
  // uomList,
  // lpcoTypeList,
  // dateQualifierList,
  externalCheckbox,
  // showAddButton,
  // countryList,
  // allowDeleteAll,
  clearErrors,
  pgaIsCompletedByGuid,
  clearPGAFlag,
  allVoluntaryPGAs,
  voluntary_Baz,
  isDisclaimSection,
  parentThis
}) => {
  
  let disclaimCodes = paramyToDisclaimCodes(hsDataDtl_paramy,formType);
  for(let deet of (hsDataDtl_paramy?.pgaMetadata?.tarriffPgaDetails || [])){
    if(!deet)continue;
    for(let program of (deet.programDetails || [])){
      if(!program)continue;
      if(program.formType == formType)
        disclaimCodes=program.disclaimCodes || [];
    }
  }
  if((!disclaimCodes || disclaimCodes.length == 0) && voluntary_Baz){
    const myvoluntaryPGA = _.flatten((allVoluntaryPGAs||[]).map(aaaa=>aaaa.programDetails)).find(aaaa=>formType== aaaa.formType);
    disclaimCodes=myvoluntaryPGA?.disclaimCodes;
  }
  // const voluntaryPgaWithCodes = voluntary_Baz && disclaimCodes?.length;
  const disclaimBoxx =  <CustomCheckbox
    id={`${formType}-disclaim-${merchandiseId}`}
    className='electronic-cert-text'
    label='Disclaim ?'
    value={Boolean(pgaValues_xx.disclaimFlag.value === 'Y' ? true : false)}
    disabled={Boolean(formDisabled) || (disclaimCheckboxdisabledxf(formType,hsDataDtl_paramy, pgaValues_xx)  && !voluntary_Baz) || isDisclaimSection}
    update={value => {
      let flagValue = value ? 'Y' : 'N';
      let disclaimCodeUsed = pgaValues_xx?.disclaimCode?.value || 'A'
      validateField(pgaValues_xx.disclaimFlag, `${formType}-${pgaValues_xx.disclaimFlag.id}`)

      
      if(pgaIsCompletedByGuid && clearPGAFlag){
          clearPGAFlag();
      }
      updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimFlag', flagValue)
      updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimCode', disclaimCodeUsed);
      pgaValues_xx.disclaimCode.value =  disclaimCodeUsed;
      pgaValues_xx.disclaimFlag.value =  flagValue;
      if(clearErrors){clearErrors()}
      if(parentThis){
        parentThis.setState({pgaIsSaving:true});
      }
      savePGAItemField(pgaGuid, [pgaValues_xx.disclaimCode,pgaValues_xx.disclaimFlag], merchandiseId, formType).then(response=>{
        if(parentThis){
          parentThis.setState({pgaIsSaving:false});
        }
      });
    }}
  />;
if(!disclaimCodes || disclaimCodes.length==0 )
  if( pgaValues_xx?.disclaimFlag?.value == "Y"){
    return <>
    {disclaimBoxx}
    <span style={{color:'red'}}><br/>Warning: no disclaim codes for this PGA. You must provide the requested information.<br/></span>
  </>} else{
    return <></>;

  }
;
if (!formDisabled) {
  if(!window["setGuid"+pgaGuid] && (!pgaValues_xx.disclaimCode.value || !((disclaimCodes||[]).includes(pgaValues_xx.disclaimCode.value)))){
    window["setGuid"+pgaGuid]=true;
    updatePGAField(pgaGuid, formType,merchandiseId, 'disclaimCode', disclaimCodes[0]);
    pgaValues_xx.disclaimCode.value = disclaimCodes[0];
    savePGAItemField(pgaGuid, [pgaValues_xx.disclaimCode,pgaValues_xx.disclaimFlag], merchandiseId, formType)
    
  }
}
 return (
  <React.Fragment>
     {!externalCheckbox && disclaimBoxx}
    {pgaValues_xx.disclaimFlag.value === 'Y'  && <>{/*start disclaim section*/}
            {pgaValues_xx?.commercialDesc &&  
            <div>
              <Form.Group className='merged-row'>
                <InputField
                  id={`${formType}-${pgaValues_xx.commercialDesc.id}`}
                  label='COMMERCIAL DESCRIPTION'
                  width={8}
                  value={pgaValues_xx.commercialDesc.value}
                  // errors={this.state.errorMsg[`${formType}-${pgaValues_xx.commercialDesc.id}`]}
                  onChange={(value) => {
                    updatePGAField(pgaGuid, formType, merchandiseId, pgaValues_xx.commercialDesc.key, value)
                  }}
                  onBlur={() => {
                    // let error = this.validateField(pgaValues_xx.commercialDesc, `${formType}-${pgaValues_xx.commercialDesc.id}`);
                    savePGAField(pgaGuid, formType, merchandiseId, lineItemIndex, pgaValues_xx.commercialDesc.key)
                  }}
                  {...FIELD_META}
                />
              </Form.Group>
            </div>}
            <div className='tsca-disclaimer-descr'>
              <p>Valid Codes are: </p>
            </div>
            <Form.Group className='merged-row'>
              {["A","B","C","D","E"].map(oneCode=><React.Fragment key={oneCode+"1234"}>
              {disclaimCodes.indexOf(oneCode)>=0 &&
                <Grid.Column width={4} className='tsca-code-column' style={{width:'50%'}}>
                  <div
                    className={
                      pgaValues_xx.disclaimCode.value === oneCode
                        ? 'buttons-tsca selected'
                        : 'buttons-tsca'
                    }
                    onClick={() => {
                      if (!formDisabled) {
                        
                        updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimFlag', 'Y')
                        updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimCode', oneCode);
                        pgaValues_xx.disclaimCode.value =  oneCode;
                        pgaValues_xx.disclaimFlag.value =  'Y';
                        savePGAItemField(pgaGuid, [pgaValues_xx.disclaimCode,pgaValues_xx.disclaimFlag], merchandiseId, formType)
                      }
                    }}
                  >
                    <div className='code-letter'>{oneCode}</div>
                    <div className='code-description'>
                       {disclaimReasonsPGAReasons[oneCode]}
                      </div>
                  </div>
                </Grid.Column>
              }
              </React.Fragment>)}
            </Form.Group>
            <br/>
            <br/>
            {(disclaimCodes && disclaimCodes.length>0) &&  pgaValues_xx.disclaimCode.value? 
             <span>
                Selected Disclaim Code: <b>{pgaValues_xx.disclaimCode.value}</b>
              </span>:
              <span style={{color:"red"}}>
                  Make sure to select a disclaim code!
              </span>}
            <br/>
            {/*end disclaim section*/}</>}
          </React.Fragment>
 )}

export default DisclaimCodes;